import { RecomendationsForIndicators } from './RecomendationsForIndicators';

export default RecomendationsForIndicators;